/** Let the browser save `blob` as `filename`. */
export const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking synchronously can cancel the download before the browser starts it.
  setTimeout(() => window.URL.revokeObjectURL(url), 2000);
};
